import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCouple$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCouple extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1260c8d5f99e3ec9394af06802937ae4c0034111', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '23e3f1a4e6daa1db0f8e4b44948a5d22ad735553', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'bc95760d0583f50d9e88b971854139962c04d013', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.5 5.5A.5.5 0 0 0 18 5v-.5a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 .5.5zM4.5 8a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5zm1 1.5h3v3h-3zm7-1.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5zm1 1.5h3v3h-3zm4.5 8a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V17a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-couple", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-couple"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-couple":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCouple$1);
            }
            break;
    } });
}

const CosmosIconCouple = CosmosIconCouple$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCouple, defineCustomElement };
